import React, { useState, useRef, useEffect } from "react"
import PageTitle from "../components/PageTitle";
import Index from "../view/ProductFilter/Index";
// import { useLocation } from "react-router-dom";
import { setLanguage, setLogout } from "../redux/user/user.action";
// import { useNavigate, useParams } from "react-router-dom";
import ApiCall from "../common/ApiCall";
import { useDispatch, useSelector } from "react-redux";
import flatpickr from "flatpickr";
import moment from "moment";
import { convertToTime, convertToTitleCase, generateSlug, getLangBySlug, getLinkNameByLang, getNameByLang, getSlugByLang, getSlugNameByLang, revertSlug } from "../common/Helper";
import noUiSlider from "nouislider";
import "nouislider/dist/nouislider.css";
import { useLocation, useParams, useSearchParams, useNavigate } from "react-router-dom";
import { setSearchHistory } from "../redux/global/global.action";
import HomeIcon from "../components/Iocns/HomeIcon";




export default function ProductFilterController() {
    const [searchParams, setSearchParams] = useSearchParams();
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    // const locationName = queryParams.get("location_name");
    // const attraction = queryParams.get("attraction");
    const global = useSelector((state) => state.global);
    const user = useSelector((state) => state.user);

    const [locationName, setLocationName] = useState(searchParams.get("location_name") || "");
    const [attraction, setAttraction] = useState(searchParams.get("attraction") || "");
    const [date, setDate] = useState(searchParams.get("date") || "");
    const [minTime, setMinTime] = useState(searchParams.get("min_time") || null);  // 00:00 in minutes
    const [maxTime, setMaxTime] = useState(searchParams.get("max_time") || null); // 24:00 in minutes
    const [fromPrice, setFromPrice] = useState(searchParams.get("from_price") || null);
    const [toPrice, setToPrice] = useState(searchParams.get("to_price") || null);

    const [isWheelChair, setIsWheelChair] = useState(searchParams.get("is_wheelchair") === "true");
    const [isFreeCancellation, setIsFreeCancellation] = useState(searchParams.get("is_free_cancellation") === "true");
    const [isPetsEnable, setIsPetsEnable] = useState(searchParams.get("is_pets_enable") === "true");
    const [selectedLangs, setSelectedLangs] = useState(searchParams.getAll("langs") || []);
    const [selectedCategories, setSelectedCategories] = useState(searchParams.get('categories') ? searchParams.get('categories').split(',') : []);
    const [currentPage, setCurrentPage] = useState(Number(searchParams.get("page")) || 1);

    const [isLoading, setIsLoading] = useState(true);
    const [productList, setProductList] = useState([]);
    const perems = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [limit, setLimit] = useState(10);
    const [totalItems, setTotalItems] = useState(0);
    const [totalPages, setTotalPages] = useState(1);
    // const [currentPage, setCurrentPage] = useState(1);
    const [value, setValue] = useState("");
    const [minValue, setMinValue] = useState(0);  // 00:00 in minutes
    const [maxValue, setMaxValue] = useState(1440); // 24:00 in minutes
    // const [date, setDate] = useState(moment().format('Y-MM-DD'));


    const calendarRef = useRef();
    const [flatpickrInstance, setFlatpickrInstance] = useState(null);
    const [locationDetails, setLocationDetails] = useState(null);
    const [filterDurationTab, setFilterDurationTab] = useState('');


    const [xAxisLabels, setXAxisLabels] = useState([]);
    const [chartData, setChartData] = useState([]);
    const [sliderValue, setSliderValue] = useState([0, 0]);

    const [minPriceValue, setMinPriceValue] = useState(null);
    const [maxPriceValue, setMaxPriceValue] = useState(null);



    const [categories, setCategories] = useState([]);
    const [categorySearch, setCategorySearch] = useState(false);
    const [tempCategories, setTempCategories] = useState([]);
    const [tempFeatures, setTempFeatures] = useState([]);



    const [showAllCat, setShowAllCat] = useState(false);

    const [showAllFe, setShowAllFe] = useState(false);


    const NormalSlider = (logValue) => {
        if (logValue < 1) return minpos; // Handle edge cases

        const minpos = 0;
        const maxpos = maxPriceValue;
        const minlval = Math.log(1);
        const maxlval = Math.log(maxPriceValue);
        const scale = (maxlval - minlval) / (maxpos - minpos);

        return minpos + (Math.log(Math.max(logValue, 1)) - minlval) / scale;
    };

    const [breadcrumbArray, setBreadcrumbArray] = useState([]);
    const [destinationSuggetions, setDestinationSuggetions] = useState([]);
    const [activitiesSuggetion, setActivitiesSuggetion] = useState([]);
    const [productsSuggetion, setProductsSuggetion] = useState([]);
    const [blogsSuggetion, setBlogsSuggetion] = useState([]);
    const [isSearchLoading, setIsSearchLoading] = useState(false);

    const [categoryInput, setCategoryInput] = useState("");
    const [featureSearch, setFeatureSearch] = useState(false);
    const [featureInput, setFeatureInput] = useState("");
    const [tempFromPrice, setTempFromPrice] = useState(0);
    const [tempToPrice, setTempToPrice] = useState(1);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);

    const [isOpen, setIsOpen] = useState(false);

    const [features, setfeatures] = useState([
        // {
        //     label: "Free cancellation",
        //     type: "cancellation",
        //     product_count: 0
        // },
        // {
        //     label: "Wheelchair accessible",
        //     type: "wheelchair",
        //     product_count: 0
        // },
        // {
        //     label: "Admits pets",
        //     type: "pets",
        //     product_count: 0
        // },
    ]);
    const sliderRef = useRef(null);
    const [selectedRange, setSelectedRange] = useState([0, 0]);

    const searchHistory = global?.searchHistory
    const [suggetionHistory, setSuggetionHistory] = useState([]);
    const typingTimer = useRef(null);
    const slugLinkField = getLinkNameByLang(user?.language)
    const slugNameField = getSlugNameByLang(user?.language)
    const slugLang = getSlugByLang(user?.language)
    const [activeSlider, setActiveSlider] = useState(null);
    const [activeTimeSlider, setActiveTimeSlider] = useState(null);



    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            navigate('/search?location_name=' + value)
        }
    };

    const getFilterProducts = async (search, signal) => {
        setIsLoading(true)
        let data = {}
        var slugField = "";
        let lang = getLangBySlug(perems?.lang)
        slugField = getSlugNameByLang(lang)
        // if (user?.language != lang) {
        //     dispatch(setLanguage(lang))
        // }
        data.field = slugField
        data.page = currentPage
        data.search = revertSlug(search)
        data.location_name = locationName ? (locationName) : null
        data.attraction = attraction ? revertSlug(attraction) : null
        data.limit = limit
        data.start_time_from = minTime
        data.start_time_to = maxTime
        data.fromPrice = fromPrice
        data.toPrice = toPrice
        // data.categories = selectedCategories
        data.isWheelChair = isWheelChair
        data.isPetsEnable = isPetsEnable
        data.selectedLangs = selectedLangs
        data.isFreeCancellation = isFreeCancellation
        // if (filterDurationTab && date) {
        data.date = date
        data.userId = user?.userDetails?.id

        // }
        const validCategories = selectedCategories.filter(cat => cat !== '');

        if (validCategories.length > 0) {
            data.categories = validCategories
        }





        const recordList = await ApiCall('post', 'product-search', data, null, false, signal)

        if (recordList) {
            if (recordList?.data?.success) {
                setProductList(recordList.data.data)
                setTotalPages(recordList.data.last_page);
                setTotalItems(recordList?.data?.total)
                setMinPriceValue(Math.round(recordList.data.minAmount))
                setMaxPriceValue(Math.round(recordList.data.maxAmount))

                if (fromPrice == null && toPrice == null) {
                    setTempToPrice(Math.round(recordList.data.maxAmount))
                }

                // setCategories(recordList.data.categories)
                // setTempCategories(recordList.data.categories)

                let filterCat = recordList.data.firstCatDetail;
                if (filterCat) {


                    var nameField = getNameByLang(user?.language)
                    var name = filterCat?.[nameField] ? filterCat?.[nameField] : filterCat?.name
                    setValue(name)
                    if (name) {

                        let breadcrumbAr = [
                            {
                                name: <HomeIcon />,
                                url: (slugLang ? ('/' + slugLang) : '')
                            },
                            {
                                name: 'Search',
                            },
                            {
                                name: name,
                            }
                        ]
                        setBreadcrumbArray(breadcrumbAr)
                    }
                } else {
                    setValue('')
                    setBreadcrumbArray([])


                }

                let ftrs = [{
                    label: "Free cancellation",
                    type: "cancellation",
                    product_count: recordList?.data?.freeCancellationCount
                },
                {
                    label: "Wheelchair accessible",
                    type: "wheelchair",
                    product_count: recordList?.data?.wheelChairCount
                },
                {
                    label: "Admits pets",
                    type: "pets",
                    product_count: recordList?.data?.petsPermittedCount
                },]

                // setfeatures([...featurs, ...recordList.data.hostLanguages])
                setfeatures([
                    ...ftrs,
                    ...recordList.data.hostLanguages.map(item => ({
                        ...item,
                        label: `Only Activities ${item.label}`
                    }))
                ])
                // setTempFeatures([...featurs, ...recordList.data.hostLanguages])
                setTempFeatures([
                    ...ftrs,
                    ...recordList.data.hostLanguages.map(item => ({
                        ...item,
                        label: `Only Activities ${item.label}`
                    }))
                ])
                let locationDetails = recordList?.data?.getLocationDetail
                if (locationDetails) {
                    setLocationDetails(locationDetails)
                    var nameField = getNameByLang(user?.language)
                    var name = locationDetails?.[nameField] ? locationDetails?.[nameField] : locationDetails?.name



                    setValue(name)
                    let breadCrmb = [
                        {
                            name: <HomeIcon />,
                            url: (slugLang ? ('/' + slugLang) : '/en')
                        },
                        {
                            name: 'Search',
                        },
                    ];
                    let locationBreadCrumb = recordList.data?.locationBreadCrumb

                    if (locationBreadCrumb.length > 0) {
                        locationBreadCrumb.map((loc, i) => {
                            breadCrmb.push({
                                name: loc?.[nameField],
                                url: (slugLang ? ('/' + slugLang) : '') + '/location' + loc?.[slugLinkField]
                            })
                        })

                        setBreadcrumbArray(breadCrmb)
                    }
                }

                setIsLoading(false)



            } else {
                if (recordList?.data?.message == 'Unauthorized' || recordList?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + slugLang + '/login')
                } else {
                    // navigate(-1)
                }
                setIsLoading(false)
            }
        }
    };

    const handleFilterClick = () => {
        setIsOpen(!isOpen);
    };

    const handleOutsideClick = (event) => {

        const mobileToursTab = document.querySelector('.mobiletoursTab');

        // Check if the tab is open and click is outside the specified elements
        if (isOpen && mobileToursTab && !event.target.closest('.toursTab, .btnFilter, .seeMore, .seeLess')) {
            setIsOpen(false);
        }
    };

    const updateURL = () => {
        const params = new URLSearchParams();
        if (locationName) params.set("location_name", locationName);
        if (attraction) params.set("attraction", attraction);
        if (date) params.set("date", date);
        if (minTime) params.set("min_time", minTime);
        if (maxTime) params.set("max_time", maxTime);
        if (fromPrice) params.set("from_price", fromPrice);
        if (toPrice) params.set("to_price", toPrice);
        if (isWheelChair) params.set("is_wheelchair", isWheelChair);
        if (isFreeCancellation) params.set("is_free_cancellation", isFreeCancellation);
        if (isPetsEnable) params.set("is_pets_enable", isPetsEnable);
        if (selectedLangs.length > 0) params.set('langs', selectedLangs.join(',')); // If needed
        // const validCategories = selectedCategories.filter(cat => cat.trim() !== '');
        const validCategories = selectedCategories?.filter(cat => cat !== '');
        if (validCategories.length > 0) params.set('categories', validCategories.join(','));
        if (currentPage > 1) params.set("page", currentPage);

        // navigate({ search: params.toString() }, { replace: true });
        // let queryString = params.toString();
        // const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;

        // window.history.pushState({}, '', newUrl);

        let queryString = decodeURIComponent(params.toString());
        const newUrl = queryString ? `${window.location.pathname}?${queryString}` : window.location.pathname;
        // window.history.pushState({}, '', newUrl);
        if (window.location.pathname + window.location.search !== newUrl) {
            window.history.pushState({}, '', newUrl);
        }
    };


    useEffect(() => {
        document.addEventListener('click', handleOutsideClick);
        document.addEventListener('touchstart', handleOutsideClick);

        return () => {
            document.removeEventListener('click', handleOutsideClick);
            document.removeEventListener('touchstart', handleOutsideClick);
        };
    }, [isOpen]);


    useEffect(() => {

        if (fromPrice) {
            setTempFromPrice(fromPrice ? Number(fromPrice) > 1 ?
                NormalSlider(Number(fromPrice)) : fromPrice : 0)
        }
        if (toPrice) {
            setTempToPrice(toPrice ? NormalSlider(Number(toPrice)) : 1)
        }
    }, [productList.length, fromPrice, toPrice]);



    useEffect(() => {
        updateURL();
        const controller = new AbortController();
        const signal = controller.signal;

        (async () => {
            let searchType = '';
            let search = '';
            if (locationName) {
                searchType = 'location_name'
                search = locationName
            }
            if (attraction) {
                searchType = 'attraction'
                search = attraction
            }

            try {
                await getFilterProducts(search, signal);
            } catch (error) {
                if (error.name !== "AbortError") {
                    console.error("API error:", error);
                }
            }


        })();
        return () => {
            controller.abort(); // Cancel the previous API call when dependencies change
        };
    }, [
        // location,
        locationName, attraction, date, minTime, maxTime, fromPrice, toPrice,
        isWheelChair, isFreeCancellation, isPetsEnable, selectedLangs,
        selectedCategories, currentPage
    ]);

    const onPageChange = (page) => {
        setCurrentPage(page);
        requestAnimationFrame(() => {
            window.scrollTo(0, 0);
        });
    };

    const onClickSearchArrow = () => {
        // if (value) {
        navigate((slugLang ? ('/' + slugLang) : '') + '/search?location_name=' + value)
        // }
    }

    const onClickTab = (type) => {
        setFilterDurationTab(type)
        if (type == 'today') {
            let filterDt = moment().format('Y-MM-DD');

            setDate(filterDt)
            setCurrentPage(1)
        }
        if (type == 'tomorrow') {
            let filterDt = moment().add(1, 'day').format('Y-MM-DD');
            setDate(filterDt)
            setCurrentPage(1);
        }

    }

    useEffect(() => {
        if (flatpickrInstance) {
            flatpickrInstance?.destroy();
        }
        const currentMonth = new Date().getMonth(); // 0-indexed (Jan = 0)
        const currentYear = new Date().getFullYear();

        const today = new Date();
        const tomorrow = new Date();

        const formatDate = (date) => date.toISOString().split("T")[0];

        const selectedDateFormatted = date ? formatDate(new Date(date)) : null;
        if (selectedDateFormatted) {
            setFilterDurationTab('dates')
        }

        const instance = flatpickr(calendarRef.current, {
            showMonths: 1,
            dateFormat: "Y-m-d",
            inline: true,
            minDate: new Date(),
            locale: {
                firstDayOfWeek: 1,

            },
            defaultDate: selectedDateFormatted,
            // mode: "range",

            defaultMonth: currentMonth, // Always use current month
            defaultYear: currentYear,   // Always use current year

            onReady: function (selectedDates, dateStr, instance) {

                instance.input.style.display = 'none';

            },
            onChange: function (selectedDates, dateStr, instance) {

                setDate(dateStr)


            },

        });

        setFlatpickrInstance(instance);


        return () => {

        };

    }, []);

    const handleMinChange = (e) => {
        const value = Math.min(e.target.value, maxValue - 1); // Prevent minValue from exceeding maxValue
        setMinValue(value);
    };

    const handleMaxChange = (e) => {
        const value = Math.max(e.target.value, minValue + 1); // Prevent maxValue from being less than minValue
        setMaxValue(value);
    };

    const handleEnd = (e) => {
        // console.log(convertToTime(minValue));
        // console.log(convertToTime(maxValue));

        setMinTime(convertToTime(minValue))
        setMaxTime(convertToTime(maxValue))
        // if (e.target.id == 'slider-min') {
        //     setMinTime(convertToTime(e.target.value))
        // } else {
        //     setMaxTime(convertToTime(e.target.value))
        // }

    };

    const getPosition = (value) => {
        return (value / 1440) * 100; // This converts the value to a percentage of the slider range (0 to 1440)
    };

    const resetFilter = () => {
        setFlatpickrInstance(null)
        setDate('')
        setFilterDurationTab('')
        setMinTime(null)
        setMaxTime(null)
        setMinValue(0)
        setMaxValue(1440)

        setToPrice(null)
        setFromPrice(null)
        setShowAllCat(false)
        setIsPetsEnable(false)
        setIsWheelChair(false)
        setSelectedLangs([])
        // setSliderValue([0, 7])
        // setTempToPrice(0)
        setTempFromPrice(0)
        setShowAllFe(false)
        setIsFreeCancellation(false)
        if (attraction) {
            // setSelectedCategories([revertSlug(attraction)])
            setSelectedCategories([attraction])

        } else {
            setSelectedCategories([])
        }

        setFeatureSearch(false)
        setFeatureInput('')
        setfeatures(tempFeatures)
        setCategorySearch(false)
        setCategoryInput('')
        setCurrentPage(1)
        // setCategories(tempCategories)


        if (attraction) {
            navigate('/search?attraction=' + (attraction))
        } else {

            navigate('/search?location_name=' + (locationName))
            // navigate('/search')
            // setLocationName('')
        }
        setIsOpen(false)

        // navigate('/search?location_name=' + generateSlug(value))
    }



    const LogSlider = (position) => {
        const minpos = 0;
        const maxpos = maxPriceValue
        const minlval = Math.log(1);
        const maxlval = Math.log(maxPriceValue);
        const scale = (maxlval - minlval) / (maxpos - minpos);
        return Math.exp((position - minpos) * scale + minlval);
    };



    // const onSliderChange = (e) => {


    //     if (e.target.id == 'slider-min') {

    //         const value1 = Math.min(Number(e.target.value), Number(tempToPrice) - 1);

    //         setTempFromPrice(value1)
    //     } else {
    //         const value = Math.max(Number(e.target.value), Number(tempFromPrice) + 1);
    //         setTempToPrice(value)
    //     }



    // };


    // const handleEndPrice = (e) => {
    //     setFromPrice(tempFromPrice > 0 ? Number(Math.round(LogSlider(tempFromPrice))) : 0)
    //     setToPrice(Number(Math.round(LogSlider(tempToPrice))))
    // };

    const onSliderChange = (e) => {
        const id = e.target.id;
        const value = Number(e.target.value);

        if (id === "slider-min") {
            if (value >= tempToPrice) return; // stop if going beyond max
            setTempFromPrice(value);
        }
        if (id === "slider-max") {
            if (value <= tempFromPrice) return; // stop if going below min
            setTempToPrice(value);
        }
    };



    const handleEndPrice = () => {
        const fromVal = tempFromPrice > 0 ? Math.round(LogSlider(tempFromPrice)) : 0;
        const toVal = Math.round(LogSlider(tempToPrice));

        // Prevent saving invalid range to URL
        if (fromVal >= toVal) return;

        setFromPrice(fromVal);
        setToPrice(toVal);
    };




    const handleSeeMoreClick = () => {
        setShowAllCat(true); // Show all categories
    };

    const handleSeeLessClick = () => {
        setShowAllCat(false); // Show only the first 4 categories
    };

    const handleCheckboxChange = (categoryName) => {
        // Create a copy of the selected categories array
        const updatedSelectedCategories = [...selectedCategories];

        // Check if the category is already selected
        if (updatedSelectedCategories.includes(categoryName)) {
            // If category is already selected, remove it
            const index = updatedSelectedCategories.indexOf(categoryName);
            updatedSelectedCategories.splice(index, 1);
        } else {
            // If category is not selected, add it
            updatedSelectedCategories.push(categoryName);
        }

        setSelectedCategories(updatedSelectedCategories);
    };

    // const handleCheckboxChange = (categoryName) => {
    //     // Normalize the category name to lowercase for case-insensitive comparison
    //     const lowerCaseCategoryName = categoryName.toLowerCase();

    //     // Create a copy of the selected categories array and normalize it
    //     const updatedSelectedCategories = [...selectedCategories.map(cat => cat.toLowerCase())];

    //     // Check if the category is already selected (case-insensitive)
    //     if (updatedSelectedCategories.includes(lowerCaseCategoryName)) {
    //         // If category is already selected, remove it
    //         const index = updatedSelectedCategories.indexOf(lowerCaseCategoryName);
    //         updatedSelectedCategories.splice(index, 1);
    //     } else {
    //         // If category is not selected, add it
    //         updatedSelectedCategories.push(lowerCaseCategoryName);
    //     }

    //     // Set the updated categories (optional: keep original case if required)
    //     setSelectedCategories(
    //         updatedSelectedCategories.map(cat =>
    //             selectedCategories.find(originalCat => originalCat.toLowerCase() === cat)?.trim() || cat
    //         )
    //     );
    // };

    const handleSeeFeMoreClick = () => {
        setShowAllFe(true); // Show all categories
    };

    const handleSeeFeLessClick = () => {
        setShowAllFe(false); // Show only the first 4 categories
    };

    const handleFeatureCheckboxChange = (e, data) => {

        // console.log(e.target.checked);



        if (data.type == 'wheelchair') {
            // setIsWheelChair(e.target.checked)
            setIsWheelChair(!isWheelChair)

        }
        if (data.type == 'pets') {
            // setIsPetsEnable(e.target.checked)
            setIsPetsEnable(!isPetsEnable)
        }
        if (data.type == 'cancellation') {
            // setIsFreeCancellation(e.target.checked)
            setIsFreeCancellation(!isFreeCancellation)
        }

        if (data.type == 'language') {

            const updatedSelectedLangs = [...selectedLangs];

            if (updatedSelectedLangs.includes(data.name)) {
                // If category is already selected, remove it
                const index = updatedSelectedLangs.indexOf(data.name);
                updatedSelectedLangs.splice(index, 1);
            } else {
                // If category is not selected, add it
                updatedSelectedLangs.push(data.name);
            }

            setSelectedLangs(updatedSelectedLangs);

        }
        // Reset the current page when the language selection changes
        setCurrentPage(1);
    }

    const checkFeatureSelected = (data) => {

        if (data.type == 'wheelchair') {
            return isWheelChair
        }
        if (data.type == 'pets') {
            return isPetsEnable
        }

        if (data.type == 'cancellation') {
            return isFreeCancellation
        }

        if (data.type == 'language') {
            return selectedLangs.includes(data.name)
        }
        return false;

    }


    const handleClickOutside = (event) => {
        if (dropdownRef?.current && !dropdownRef?.current.contains(event?.target)) {
            setDestinationSuggetions([])
            setActivitiesSuggetion([])
            setProductsSuggetion([])
            setBlogsSuggetion([])
            setShowDropdown(false); // Hide dropdown when clicking outside
        }
    };

    useEffect(() => {
        // Check if the script is already loaded to avoid loading it multiple times

        const script = document.createElement('script');
        script.src = 'https://cdn.trustindex.io/loader.js';
        script.async = true;
        script.defer = true;
        document.head.appendChild(script);

        // Cleanup: Remove the script when the component is unmounted
        return () => {
            document.head.removeChild(script);
        };
    }, [productList]);

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    const getSearchSuggetions = async (search) => {
        setIsSearchLoading(true)
        var lang = getSlugByLang(user?.language);
        let data = {}
        data.search = search
        data.lang = lang

        const recordList = await ApiCall('post', 'search-suggetions', data)
        setIsSearchLoading(false)
        if (recordList) {
            if (recordList?.data?.success) {


                setDestinationSuggetions(recordList.data.data.destinations)
                setActivitiesSuggetion(recordList.data.data.activities);
                setProductsSuggetion(recordList.data.data.products)
                setBlogsSuggetion(recordList.data.data.blogs)
            }
        }
    };

    const onCategoryChange = (e) => {
        setCategoryInput(e.target.value)
        if (e.target.value) {
            const filteredCategories = tempCategories.filter(cat =>
                cat.name.toLowerCase().includes(e.target.value.toLowerCase())
            );
            setCategories(filteredCategories)
        } else {
            setCategories(tempCategories)
        }
    }

    const onResetCategory = (e) => {
        setCategorySearch(false)
        setCategoryInput('')
        setCategories(tempCategories)
        setShowAllCat(false)
    }

    const onFeatureChange = (e) => {
        setFeatureInput(e.target.value)
        if (e.target.value) {

            const filteredRec = tempFeatures.filter(fe =>
                fe.label.toLowerCase().includes(e.target.value.toLowerCase())
            );
            setfeatures(filteredRec)
        } else {
            setfeatures(tempFeatures)
        }
    }


    const onResetFeature = (e) => {
        setFeatureSearch(false)
        setFeatureInput('')
        setfeatures(tempFeatures)
        setShowAllFe(false)
    }






    const handleKeyUp = async (e) => {

        const value = e.target.value;
        clearTimeout(typingTimer.current); // Clear previous timer

        if (value.trim().length === 0) {
            setDestinationSuggetions([])
            setActivitiesSuggetion([])
            setProductsSuggetion([])
            setBlogsSuggetion([])
            // setSearchValue('');
        }
        setIsSearchLoading(false);
        if (value.length >= 3) {
            setIsSearchLoading(true);
            typingTimer.current = setTimeout(() => {
                getSearchSuggetions(value);
            }, 500); // Call function only after 0.5s of no typing
        }
        // setSearchValue(value);
    };

    const updateSearchHistory = (rec) => {
        let sh = searchHistory ? searchHistory : []
        let hist = [...sh]


        if (!hist.some(item => item?.url === rec?.url)) {

            if (hist.length >= 5) {
                hist.pop();
            }
            hist.unshift(rec);
            dispatch(setSearchHistory(hist));
        }

    }


    const onClickDestination = (destination, sublabel, slug) => {
        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/search?location_name=' + destination
        let dta = {
            label: destination,
            // url: '/search?location_name=' + slug,
            url: url,
            sublabel: sublabel
        }
        updateSearchHistory(dta)
        // let slug = generateSlug(destination)
        setValue(destination)
        setShowDropdown(false);
        setSelectedCategories([])
        setLocationName(slug)
        setCurrentPage(1)
        // navigate('/search?location_name=' + slug)
    }

    const onClickActivity = (id, activity, slug) => {
        // let slug = generateSlug(activity)
        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/search?categories=' + id
        let dta = {
            label: activity,
            // url: '/search?categories=' + id,
            url: url,
            sublabel: null
        }
        updateSearchHistory(dta)
        setCurrentPage(1)

        setLocationName('')
        setShowDropdown(false);
        setSelectedCategories([id])
        setValue(activity)
        let breadcrumbAr = [
            {
                name: <HomeIcon />,
                url: (slugLang ? ('/' + slugLang) : '/')
            },
            {
                name: 'Search',
            },
            {
                name: activity,
            }
        ]
        setBreadcrumbArray(breadcrumbAr)

    }



    const onClickProduct = (name, sublabel, slug) => {
        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/tour/' + slug
        let dta = {
            label: name,
            // url: `/tour/${slug}`,
            url: url,
            sublabel: sublabel
        }
        updateSearchHistory(dta)
        navigate(url)


    }

    const onClickBlog = (name, slug) => {
        const slugLang = getSlugByLang(user?.language)
        let url = (slugLang ? ('/' + slugLang) : '') + '/blog/article/' + slug

        let dta = {
            label: name,
            url: url,
            sublabel: null
        }
        updateSearchHistory(dta)

        navigate(url)
    }



    useEffect(() => {
        setSuggetionHistory(searchHistory)
    }, [searchHistory]);


    useEffect(() => {

        if (user?.language != "Other") {



            const slugField = getSlugNameByLang(user?.language)
            // console.log('slugField', slugField);
            // console.log('locationDetails', locationDetails);

            // console.log('locationDetails?.[slugField]', locationDetails?.[slugField]);


            if (slugField && locationDetails?.[slugField]) {
                setLocationName(locationDetails?.[slugField])
            }
        }

        return () => {
            console.log('cleanup');
        };

    }, [user?.language, locationDetails]);




    const onClickHistoryOption = (url) => {
        if (url.includes("/search?")) {
            const params = new URLSearchParams(url.split("?")[1]);  // Get query parameters
            if (params.has("categories")) {
                setCurrentPage(1)
                setSelectedCategories([params.get("categories")])
            } else if (params.has("location_name")) {
                setLocationName(params.get("location_name"))
                setCurrentPage(1)
            }
            setShowDropdown(false)
        } else {
            navigate(url)
        }

    }

    const toggleLike = async (liked, indx, id) => {

        let prodList = [...productList]
        prodList[indx].liked = !liked
        setProductList(prodList)

        if (!user.token) {
            navigate('/' + slugLang + '/login')
            return false
        }
        // setIsLoading(true)
        let data = {};
        data.product_id = id
        data.isLiked = !liked
        const likeUnlikeProduct = await ApiCall('post', 'toggle-product-like', data, user.token)
        if (likeUnlikeProduct) {

            if (likeUnlikeProduct?.data?.success) {

            } else {
                if (likeUnlikeProduct?.data?.message == 'Unauthorized' || likeUnlikeProduct?.data?.error == 'Unauthorized') {
                    dispatch(setLogout())
                    navigate('/' + slugLang + '/login')
                }
            }
        }

    }

    return (
        <>
            <PageTitle title={'Search Product'} />
            <Index
                productList={productList}
                currentPage={currentPage}
                totalPages={totalPages}
                totalItems={totalItems}
                onPageChange={onPageChange}
                isLoading={isLoading}
                value={value}
                setValue={setValue}
                handleKeyDown={handleKeyDown}
                onClickSearchArrow={onClickSearchArrow}
                calendarRef={calendarRef}
                filterDurationTab={filterDurationTab}
                setFilterDurationTab={setFilterDurationTab}
                onClickTab={onClickTab}
                handleMinChange={handleMinChange}
                handleMaxChange={handleMaxChange}
                maxValue={maxValue}
                minValue={minValue}
                handleEnd={handleEnd}
                getPosition={getPosition}
                resetFilter={resetFilter}
                xAxisLabels={xAxisLabels}
                sliderValue={sliderValue}
                onSliderChange={onSliderChange}
                maxPriceValue={maxPriceValue}
                minPriceValue={minPriceValue}
                categories={categories}
                showAllCat={showAllCat}
                handleSeeMoreClick={handleSeeMoreClick}
                handleSeeLessClick={handleSeeLessClick}
                handleCheckboxChange={handleCheckboxChange}
                selectedCategories={selectedCategories}
                features={features}
                showAllFe={showAllFe}
                handleSeeFeMoreClick={handleSeeFeMoreClick}
                handleSeeFeLessClick={handleSeeFeLessClick}
                isWheelChair={isWheelChair}
                isPetsEnable={isPetsEnable}
                handleFeatureCheckboxChange={handleFeatureCheckboxChange}
                checkFeatureSelected={checkFeatureSelected}
                fromPrice={fromPrice}
                toPrice={toPrice}
                tempFromPrice={tempFromPrice}
                tempToPrice={tempToPrice}
                handleEndPrice={handleEndPrice}
                LogSlider={LogSlider}
                handleFilterClick={handleFilterClick}
                isOpen={isOpen}
                breadcrumbArray={breadcrumbArray}
                dropdownRef={dropdownRef}
                showDropdown={showDropdown}
                setShowDropdown={setShowDropdown}
                handleKeyUp={handleKeyUp}
                isSearchLoading={isSearchLoading}

                productsSuggetion={productsSuggetion}
                activitiesSuggetion={activitiesSuggetion}
                destinationSuggetions={destinationSuggetions}
                blogsSuggetion={blogsSuggetion}
                onClickProduct={onClickProduct}
                onClickDestination={onClickDestination}
                onClickBlog={onClickBlog}

                onClickActivity={onClickActivity}

                sliderRef={sliderRef}
                selectedRange={selectedRange}

                suggetionHistory={suggetionHistory}

                onClickHistoryOption={onClickHistoryOption}
                toggleLike={toggleLike}

                categoryInput={categoryInput}
                onCategoryChange={onCategoryChange}

                featureSearch={featureSearch}
                onFeatureChange={onFeatureChange}

                onResetCategory={onResetCategory}
                categorySearch={categorySearch}
                setCategorySearch={setCategorySearch}

                onResetFeature={onResetFeature}
                featureInput={featureInput}
                setFeatureSearch={setFeatureSearch}
                setActiveSlider={setActiveSlider}
                activeSlider={activeSlider}

                activeTimeSlider={activeTimeSlider}
                setActiveTimeSlider={setActiveTimeSlider}
            />
        </>
    )

}